export default __webpack_public_path__ + "static/media/Monger-HUD-Altimeter.de4d61db.jpg";